import type { BottomSheetModal } from '@gorhom/bottom-sheet';
import type { FC, PropsWithChildren } from 'react';
import { useCallback, useMemo, useRef } from 'react';

import { TutorialSheet } from '@/features/tutorial/components/TutorialSheet';
import type { TutorialContextValues } from '@/features/tutorial/providers/useTutorial';
import { TutorialContext } from '@/features/tutorial/providers/useTutorial';
import { useTutorialStore } from '@/features/tutorial/store/tutorialStore';

export const TutorialProvider: FC<PropsWithChildren> = ({ children }) => {
  const bottomSheetModalRef = useRef<BottomSheetModal>(null);
  const cardVisible = useTutorialStore((state) => state.cardVisible);
  const completed = useTutorialStore((state) => state.completed);
  const hideCard = useTutorialStore((state) => state.hideCard);
  const markCompleted = useTutorialStore((state) => state.markCompleted);

  const present = useCallback(
    () => bottomSheetModalRef.current?.present(),
    [bottomSheetModalRef]
  );

  const dismiss = useCallback(
    () => bottomSheetModalRef.current?.dismiss(),
    [bottomSheetModalRef]
  );

  const contextValues = useMemo<TutorialContextValues>(
    () => ({
      present,
      dismiss,
      cardVisible,
      completed,
      hideCard,
      markCompleted
    }),
    [present, dismiss, cardVisible, completed, hideCard, markCompleted]
  );

  return (
    <TutorialContext.Provider value={contextValues}>
      {children}
      <TutorialSheet ref={bottomSheetModalRef} />
    </TutorialContext.Provider>
  );
};
